<form [formGroup]="form">
  <div class="d-flex justify-content-center my-3">
    @if (isRecaptchaLoaded) {
      <div id="recaptcha" class="g-recaptcha" data-type="image" [attr.data-theme]="recaptchaTheme" data-callback="recaptchaCallback" data-expired-callback="recaptchaExpired" [attr.data-sitekey]="recaptchaKey"></div>
    }
    <button class="d-none" id="recaptchaUpdateForm" (click)="updateForm()"></button>
  </div>
</form>